import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function ExamenUbicacion() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Examen de Ubicación de Inglés Gratis | Culturlingua</title>
        <meta name="description" content="Haz el examen de ubicación de inglés gratis. Conoce tu nivel A1-C2 en 10 minutos. Sin registro. Sin tarjeta." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Gratis · 10 minutos</div>
        <h1>Examen de Ubicación de Inglés</h1>
        <p>Conoce tu nivel exacto y encuentra el curso perfecto para ti.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'60px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>
          <div style={{display:'flex', gap:'12px', flexWrap:'wrap', justifyContent:'center', marginBottom:'40px'}}>
            {['⏱️ Solo 10 minutos','🆓 Completamente gratis','📱 Desde cualquier dispositivo','🏆 Resultado inmediato'].map(p => (
              <span key={p} style={{background:'white', border:'1px solid #e5e7eb', padding:'8px 18px', borderRadius:'100px', fontSize:'0.875rem', color:'var(--text)', fontWeight:'500'}}>
                {p}
              </span>
            ))}
          </div>

          {/* Contenedor del Botón para el enlace externo */}
          <div style={{background:'white', borderRadius:'20px', padding:'60px 20px', textAlign:'center', boxShadow:'0 4px 24px rgba(0,0,0,0.08)'}}>
            <h2 style={{color:'var(--navy)', marginBottom:'16px', fontSize:'1.75rem'}}>Comienza tu evaluación ahora</h2>
            <p style={{color:'var(--text)', marginBottom:'32px'}}>Haz clic en el botón de abajo para abrir el examen en una nueva pestaña.</p>
            
            {/* Recuerda cambiar "https://tu-enlace-externo.com" por la URL real de tu formulario */}
            <a 
              href="https://linguahub.culturlingua.com/gral/placement_test/examen.php" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-glow" 
              style={{display:'inline-block', fontSize:'1.1rem', padding:'16px 32px'}}
            >
              Ir al Examen de Ubicación
            </a>
          </div>

          <div style={{textAlign:'center', marginTop:'40px'}}>
            <p style={{color:'var(--muted)', marginBottom:'20px'}}>¿Ya sabes tu nivel? Encuentra el curso ideal.</p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/Cursos" className="btn-glow">Ver todos los cursos →</Link>
              <Link to="/contacto" className="btn-outline" style={{color:'var(--navy)', border:'1.5px solid var(--navy)'}}>Hablar con un asesor</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ExamenUbicacion;